import React, { useContext } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from 'react-router-dom';

import SplashScreen from './components/SplashScreen/SplashScreen';
import MainApp from './components/MainApp/MainApp';
import LoginPage from './components/LoginPage/LoginPage';
import AdminPage from './components/AdminPage/AdminPage';
import UserAdmin from './components/UserAdmin/UserAdmin';
import { UserContext } from './context/UserContext';
import axios from 'axios';

const Main = () => {
  const navigate = useNavigate();
  const { currentUser, saveCurrentUser } = useContext(UserContext);

  const handleNew = () => {
    navigate('/main');
  };

  const handleLoad = (jsonContent) => {
    navigate('/main', {
      state: {
        initialState: jsonContent,
        editingTemplate: null,
      },
    });
  };

  const handleTemplates = (jsonContent) => {
    navigate('/main', {
      state: {
        initialState: jsonContent,
        editingTemplate: jsonContent,
      },
    });
  };

  const onLoginSuccess = async (userData) => {
    saveCurrentUser(userData);
    console.log('Logged in user:', userData);

    navigate('/splash');

    try {
      const res = await axios.get(
        `https://edugroove-backend.onrender.com/api/users/${userData.id}/logos`
      );

      if (res.data?.logoUrl) {
        userData.logoUrl = res.data.logoUrl;
      } else {
        const defaultRes = await axios.get(
          'https://edugroove-backend.onrender.com/api/admin/getDefaultLogo'
        );
        userData.logoUrl = defaultRes.data.defaultLogoUrl;
      }

      saveCurrentUser({ ...userData });
    } catch (err) {
      console.error('Error fetching logo:', err);
      userData.logoUrl =
        'https://edugroove-backend.onrender.com/uploads/defaultlogo.png';
      saveCurrentUser({ ...userData });
    }
  };

  const onGuestLogin = () => {
    saveCurrentUser(null);
    navigate('/splash');
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          currentUser ? (
            <Navigate to="/splash" replace />
          ) : (
            <LoginPage
              onLoginSuccess={onLoginSuccess}
              onGuestLogin={onGuestLogin}
            />
          )
        }
      />

      <Route
        path="/splash"
        element={
          currentUser ? (
            <SplashScreen
              onNew={handleNew}
              onLoad={handleLoad}
              onTemplates={handleTemplates}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/main"
        element={
          currentUser ? <MainApp /> : <Navigate to="/" replace />
        }
      />

      <Route
        path="/user-admin"
        element={
          currentUser ? <UserAdmin /> : <Navigate to="/" replace />
        }
      />

      <Route
        path="/admin"
        element={
          currentUser ? (
            <AdminPage currentUser={currentUser} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App = () => {
  const routerBasename =
    process.env.NODE_ENV === 'production' ? '/app' : '';

  return (
    <Router basename={routerBasename}>
      <Main />
    </Router>
  );
};

export default App;